import styled from 'styled-components'
import { tint } from 'polished'

import RadioButton from 'components/RadioButton'

import { Item as BaseItem } from '../../components/SelectDropdown'

export const Bold = styled.b`
  color: ${({ theme }) => theme.colors.foreground.secondary[1]};
  font-weight: 500;
`

export const WarningWrapper = styled.div`
  margin-top: 24px;
  padding: 16px;
  border-radius: ${({ theme }) => theme.radii.large};
  background-color: ${({ theme }) => tint(0.9, theme.colors.state.warning)};
  font-size: 0.8125rem;
`

export const HeaderItem = styled.h1`
  margin: 0;

  font-size: 0.6875rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.foreground.secondary[4]};
  padding: 10px 12px; /* stylelint-disable-line scales/space */

  text-transform: uppercase;
`

export const DangerRadioButton = styled(RadioButton)`
  ${RadioButton.Label} {
    color: ${({ theme }) => theme.colors.danger};
  }
`

export const MovingTextWrapper = styled.div`
  margin-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.colors.border[2]};
  padding: 24px 0 0;
`

export const Item = styled(BaseItem)`
  &[disabled] {
    opacity: 0.5;
  }
`
